<template>
    <div style="padding: 5px 20px;">
            <div>
               <el-table :data="quesList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">

                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column label="当周任务"  size="40%">
                        <template slot-scope="scope">
                            <el-input
                                    type="textarea"
                                    :rows="1"
                                    autosize
                                    v-model="scope.row.answer" disabled maxlength="5000" show-word-limit>
                            </el-input>
                        </template>
                    </el-table-column>
                </el-table>
                </div>
            </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getCustomerList,uploadCooperativeFile,downloadExcelCooperative} from '@/api/api';
    import {getRouterPageHash} from '@/api/http';
    //import draggable from 'vuedraggable'
    import draggable from 'vuedraggable'


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                quesList:[],
                paperpage:this.param,
            }
        },
        props:['sectionClassId'],
        computed:{

        },
        components:{
            draggable
        },
        //挂载时候执行
        mounted() {
            this.getCooperativeQues(this.paperpage)
        },
        watch: {
            param(val){
                this.paperpage=val;

                this.getCooperativeQues(this.paperpage)
            }
        },
        props:['param'],
        methods: {
            getCooperativeQues(obj) {
                this.getCooperativeAllUserList();
                this.drawerShow = true;
                this.voitIs = obj.isVoit;
                this.leaderIs = obj.isLeader==2?1:obj.isLeader;
                this.periodId = obj.periodId;
                this.paperId = obj.id;
                this.userId = obj.userId;
                this.editIs = obj.isEdit;
                this.classId=obj.questionClassId;
                this.reportStatus= obj.reportStatus;
                this.isNice = obj.isNice;
                console.log("isnice:"+this.isNice)
                this.isLeaderEdit = obj.isLeaderEdit;
                this.isDissentEdit = obj.isDissentEdit;
                this.reportFinish = obj.status;//0未填写 1已填写
                this.title=obj.questionClassName+" (标*必填)"+" :【"+obj.userName+"】"+obj.periodName;
                this.$store.dispatch('initCooperativeQues',{classId:this.classId,paperId:obj.id}).then(res=>{
                    this.quesList = res
                    let arr = []
                    this.quesList.map(item=>{
                        if(item.questionType==3){
                            arr = JSON.parse(item.answer||'[]')
                        }
                        if(item.questionType==19){
                            item.answer = JSON.parse(item.answer.toString())
                        }
                        if(item.questionType==9){
                            item.answer = JSON.parse(item.answer.toString())
                        }
                        if(item.questionType==10){
                            item.subPaperAnswerEditVos.map(item1=>{
                                if(item1.questionType==9){
                                    item1.answer = JSON.parse(item1.answer.toString())
                                }
                            })

                        }
                    })
                    this.fileObjList = arr.map(item=>{
                        return {name:item.name,url:item.url}
                    })
                })
            },
             getCooperativeAllUserList() {
                 this.$store.dispatch('initCooperativeAllUserList',{type:0,classId:''}).then(res=>{
                     this.userAllList = res
                     this.selectUserList1 = res
                     this.selectUserList = res
                 })
             }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-drawer__body{
        overflow-y: scroll;
    }

    .el-textarea__inner{
        min-height: 40px !important;
    }
    .cooperate-form {
        .el-input-number{
            width: 220px !important;
        }
        .el-select{
            width: 100%;
        }
    }
    .drag-container{
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #606266;
        border-spacing: 0;
        border-collapse: collapse;
        td,th{
            padding: 12px 0;
            border:1px solid #EBEEF5;

        }
        th{
            background: #eef1f6;
            color: #222222;
            text-align: center;
        }
    }
    .el-drawer__header{
        /*color:#000000;*/
        margin-bottom:10px;
        font-size:20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/cooperative/weekJobFormValue.vue